"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var layers_manager_module_1 = require("./layers-manager.module");
exports.LayersManagerModule = layers_manager_module_1.LayersManagerModule;
var data_layers_service_1 = require("./services/data-layers.service");
exports.layersConfig = data_layers_service_1.layersConfig;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/layers-manager/index.js
// module id = ../../../../../src/app/packages/menu-items/layers-manager/index.js
// module chunks = main